export class ProjectsComparatorService {
    projectsSortByDateComparator(proj1,proj2) {
        if (proj1.isDraft && proj2.isDraft == false) {
            return 1;
        } else if (proj1.isDraft == false && proj2.isDraft) {
            return -1;
        }
        if (proj1.lastActivity != null && proj2.lastActivity != null) {
            let firstDate = new Date(proj1.lastActivity);
            let secondDate = new Date(proj2.lastActivity);
            if (firstDate.getTime() > secondDate.getTime()) {
                return -1;
            } else if (firstDate.getTime() < secondDate.getTime()) {
                return 1;
            } else {
                return 0;
            }
        }
        if (proj1.lastActivity != null && proj2.lastActivity == null) {
            return -1;
        }
        if (proj1.lastActivity == null && proj2.lastActivity != null) {
            return 1;
        }
        return proj1.name.localeCompare(proj2.name);
    }
}



// WEBPACK FOOTER //
// ./src/services/projectsComparator.js